import type { InfluencerFilters } from '../types/influencer.types';

export const influencerKeys = {
  all: ['influencers'] as const,
  lists: () => [...influencerKeys.all, 'list'] as const,
  list: (orgId: string | undefined, filters: InfluencerFilters) =>
    [
      ...influencerKeys.all,
      orgId,
      filters.searchTerm || '',
      filters.gender || 'all',
      filters.platform || 'all',
      filters.engagement || 'all',
      filters.location || 'all',
      filters.tier || 'all',
      filters.status || 'all',
      filters.page || 1,
      filters.pageSize || 20,
    ] as const,
  options: (orgId?: string) => [...influencerKeys.all, 'options', orgId] as const,
  details: () => [...influencerKeys.all, 'detail'] as const,
  detail: (id?: string) => [...influencerKeys.all, 'detail', id] as const,
  posts: (id?: string) => [...influencerKeys.all, 'posts', id] as const,
  refreshStatus: (orgId?: string) => [...influencerKeys.all, 'refresh-status', orgId] as const,
};
